import { ReactElement } from "react";
import { Typography } from "@mui/material";
import WorkflowSteps from "./WorkflowSteps.component";
import { useProjectStore } from "../stores/project.store";
import { DATA_TYPES } from "../types/dataTypes";

export interface WorkflowProps {
  className?: string;
  activeStep?: string;
  onStepSelect?: (stepId: string) => void;
  completedSteps?: string[];
}

const Workflow = ({
  className = "",
  activeStep,
  onStepSelect,
  completedSteps = [],
}: WorkflowProps): ReactElement => {
  const { selectedProject } = useProjectStore();

  const handleStepSelect = (stepId: string) => {
    // Allow clicking any step that's not disabled
    // The WorkflowSteps component handles the disabled logic
    onStepSelect?.(stepId);
  };

  // Render data-type specific workflow steps
  const renderWorkflowSteps = () => {
    if (!selectedProject) {
      return (
        <Typography variant="body2" className="text-gray-500 text-center">
          No project selected
        </Typography>
      );
    }

    // Map data types to workflow data types
    const getWorkflowDataType = (projectDataType: string) => {
      switch (projectDataType) {
        case DATA_TYPES.SINGLE_CELL:
          return "single-cell";
        // Future data types can be mapped here:
        // case DATA_TYPES.BULK_RNA:
        //   return 'bulk-rna';
        // case DATA_TYPES.PROTEOMICS:
        //   return 'proteomics';
        default:
          return "single-cell"; // Default fallback
      }
    };

    const workflowDataType = getWorkflowDataType(selectedProject.data_type);

    return (
      <WorkflowSteps
        dataType={workflowDataType}
        onStepSelect={handleStepSelect}
        completedSteps={completedSteps}
        activeStep={activeStep}
      />
    );
  };

  return (
    <div className={`h-full overflow-y-auto pr-2 ${className}`}>
      {renderWorkflowSteps()}
    </div>
  );
};

export default Workflow;
